/**
 * Dado un nombre base y sufijos tipo _day, _time, _timestamp, _d1.._d7,
 * devuelve el valor calculado desde params[base].
 */
function resolveDateDerivative(name, params) {
    const m = name.match(/^(.+?)_(day|time|timestamp|d[1-7])$/i)
    if (!m) return null
    const base = m[1]
    const kind = m[2].toLowerCase()

    let d = moment(params[base], 'DD/MM/YYYY HH:mm', true)
    if (!d.isValid() && params[base + '_timestamp'] && params[base + '_timestamp'] !== '-') {
        const ts = parseInt(params[base + '_timestamp'], 10)
        if (Number.isFinite(ts)) d = moment(ts * 1000)
    }
    if (!d.isValid()) return '-'

    if (kind === 'day') return d.format('DD/MM/YYYY')
    if (kind === 'time') return d.format('HH:mm')
    if (kind === 'timestamp') return String(Math.floor(d.valueOf() / 1000))
    if (kind[0] === 'd') {
        const target = parseInt(kind.slice(1), 10)
        return d.isoWeekday() === target ? 'x' : ' '
    }
    return '-'
}

function resolvePlaceholders(text, params) {
    if (!text) return ''

    text = text.replace(/\[([a-zA-Z0-9_]+)\]/g, (_m, key) => {
        const direct = params[key] != null ? params[key] : null
        if (direct != null) return String(direct)
        const derived = resolveDateDerivative(key, params)
        if (derived != null) return String(derived)
        return '-'
    })

    text = text.replace(/\{([a-zA-Z0-9_]+)\}/g, (_m, key) => {
        const direct = params[key] != null ? params[key] : null
        if (direct != null) return String(direct)
        const derived = resolveDateDerivative(key, params)
        if (derived != null) return String(derived)
        return '-'
    })

    return text
}

export function resolveFDText(fdRaw, values, params) {
    if (!fdRaw) return ''

    const replacedByIndex = fdRaw.replace(/\[(\d+)\]/g, (_m, nStr) => {
        const key = String(parseInt(nStr, 10))
        const mapped = values && values[key] != null ? String(values[key]) : '-'
        return mapped
    })

    return resolvePlaceholders(replacedByIndex, params)
}

export function parseZplTokens(zplText) {
    if (!zplText || typeof zplText !== 'string') return []

    const tokenRe = /([\^~])([A-Z]{1,2}|[A-Z][0-9]|[A-Z]@)([^~^]*)/g
    const tokens = []
    let m

    while ((m = tokenRe.exec(zplText)) !== null) {
        const marker = m[1]
        const code = m[2]
        const body = m[3] || ''
        tokens.push({ command: marker + code, raw: body })
    }

    const parseParams = (command, rawBody) => {
        let s = rawBody.trim()
        if (!s) return []

        if (command === '^FD') return [s]

        if (command === '^GF') {
            let head = []

            if (s[0] !== ',') {
                const i = s.indexOf(',')
                if (i === -1) return [s]
                head.push(s.slice(0, i).trim())
                s = s.slice(i + 1)
            } else {
                head.push('')
                s = s.slice(1)
            }

            const parts = s.split(',')
            const triplet = parts.slice(0, 3).map((p) => p.trim())
            const data = parts.slice(3).join(',')
            return [...head, ...triplet, data]
        }

        const out = []

        if (s[0] !== ',') {
            const i = s.indexOf(',')

            if (i === -1) {
                out.push(s.trim())
                return out
            }
            out.push(s.slice(0, i).trim())
            s = s.slice(i + 1)
        } else {
            out.push('')
            s = s.slice(1)
        }

        return out.concat(s.split(',').map((p) => p.trim()))
    }

    return tokens.map((t) => ({
        command: t.command,
        params: parseParams(t.command, t.raw)
    }))
}
